import { formatAmount, type ChatRoom } from './api';
import { oneliveAssets } from './assets';
import ChatListSearchPanel from './ChatListSearchPanel';
import { chatListAsset, resolveChatRoomThumb, roomCapacity } from './chatListShared';
import type { ChatListPageState } from './useChatListPage';

function ChatRoomRow({
  room,
  onEnter,
}: {
  room: ChatRoom;
  onEnter: (room: ChatRoom) => void;
}) {
  const cap = roomCapacity(room);
  const thumb = resolveChatRoomThumb(room, oneliveAssets.guestAvatar);

  return (
    <article className="ref-chat-room-item">
      <div className="ref-chat-room-thumb">
        <img
          src={thumb}
          alt=""
          onError={(ev) => {
            ev.currentTarget.onerror = null;
            ev.currentTarget.src = oneliveAssets.guestAvatar;
          }}
        />
      </div>
      <div className="ref-chat-room-body">
        <h4>{room.title || room.host_nickname}</h4>
        <div className="ref-chat-room-meta">
          <span>
            <img src={chatListAsset('main-user.png')} alt="" />
            {room.host_nickname}
          </span>
          <span>
            <img src={chatListAsset('ico-money.png')} alt="" />
            {formatAmount(room.coins)}
          </span>
        </div>
      </div>
      <div className="ref-chat-room-action">
        <div className="ref-chat-room-capacity">
          <img src={chatListAsset('ico-message.png')} alt="" />
          <span>{cap.current}/{cap.max}</span>
        </div>
        <button type="button" className="ref-chat-enter-btn" onClick={() => onEnter(room)}>
          입장
        </button>
      </div>
    </article>
  );
}

export default function MobileChatListView(state: ChatListPageState) {
  const {
    rooms,
    proceedingRooms,
    loading,
    searchOpen,
    setSearchOpen,
    searchTitle,
    setSearchTitle,
    searchLevel,
    setSearchLevel,
    onEnterRoom,
    onSearchSubmit,
    onResetSearch,
  } = state;

  return (
    <>
        <div className="onelive-ref-sub-title"><span>방리스트</span></div>

        <section className="ref-chat-section ref-chat-section--proceeding">
          <header className="ref-chat-section-head">
            <h3>
              <img src={chatListAsset('ico-message.png')} alt="" />
              진행중인 채팅
            </h3>
          </header>
          <div className="ref-chat-section-body">
            {loading ? (
              <p className="onelive-loading ref-chat-loading">로딩 중...</p>
            ) : proceedingRooms.length === 0 ? (
              <div className="ref-chat-empty">
                <img src={chatListAsset('mb.png')} alt="" />
                <p>진행중인 채팅방이 없습니다.</p>
              </div>
            ) : (
              proceedingRooms.map((room) => (
                <ChatRoomRow key={`proceeding-${room.id}`} room={room} onEnter={onEnterRoom} />
              ))
            )}
          </div>
        </section>

        <section className="ref-chat-section ref-chat-section--list">
          <header className="ref-chat-section-head ref-chat-section-head--actions">
            <h3>
              <img src={chatListAsset('mian-item.png')} alt="" />
              채팅방 리스트
            </h3>
            <div className="ref-chat-section-tools">
              <button type="button" className="ref-chat-tool-btn ref-chat-tool-btn--reset" onClick={onResetSearch}>
                <img src={chatListAsset('search-home.png')} alt="" />
                검색초기화
              </button>
              <button type="button" className="ref-chat-tool-btn ref-chat-tool-btn--search" onClick={() => setSearchOpen(true)}>
                <img src={chatListAsset('search-w.png')} alt="" />
                검색
              </button>
            </div>
          </header>
          <div className="ref-chat-section-body">
            {loading ? (
              <p className="onelive-loading ref-chat-loading">로딩 중...</p>
            ) : rooms.length === 0 ? (
              <div className="ref-chat-empty ref-chat-empty--compact">
                <p>등록된 채팅방이 없습니다.</p>
              </div>
            ) : (
              rooms.map((room) => (
                <ChatRoomRow key={room.id} room={room} onEnter={onEnterRoom} />
              ))
            )}
          </div>
        </section>

        <ChatListSearchPanel
          variant="mobile"
          open={searchOpen}
          searchTitle={searchTitle}
          searchLevel={searchLevel}
          onSearchTitleChange={setSearchTitle}
          onSearchLevelChange={setSearchLevel}
          onSubmit={onSearchSubmit}
          onClose={() => setSearchOpen(false)}
        />
    </>
  );
}
